import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.pages.waitlist': {
         addEntry: 'Wpisz na listę',
         addEntryToTheWaitlist: 'Wpisz na listę rezerwową',
         addPatientToTheWaitlist: 'Wpisz pacjenta na listę',
         allDays: 'Zaznacz wszystkie dni',
         anyLocation: 'Dowolna placówka',
         areYouSureRemovingPatientEntry:
            'Czy na pewno chcesz usunąć wpis dotyczący pacjenta: <bold>{{patientFullName}}</bold> z listy rezerwowej?',
         bookAppointment: 'Umów',
         category: 'Kategoria',
         changesSaved: 'Zmiany zostały zapisane.',
         chooseAll: 'Wybierz wszystkie',
         chooseAtLeastOneDayWeekAndTimePreference: 'Wybierz przynajmniej jeden dzień tygodnia i zakres godzin.',
         chooseEncounterModes: 'Wybierz typy wizyty',
         chooseHealthcareProviderLocation: 'Wybierz Miejsce Udzielania Świadczeń',
         choosePlaceholder: {
            ellipsified: 'Wybierz...',
            standard: 'Wybierz',
         },
         choosePriority: 'Wybierz status',
         chooseService: 'Wybierz usługę...',
         chooseServices: 'Wybierz usługi',
         chooseSpecialists: 'Wybierz specjalistów',
         chosenOptions: 'Wybrano {{count}} z {{totalCount}}',
         confirm: 'Potwierdź',
         confirmAppointment: 'Potwierdź termin',
         confirmAppointmentWithPatient: 'Potwierdź ustalenie terminu z pacjentem',
         date: 'Data',
         datePreferences: 'Preferencje dot. terminu: ',
         dateTime: 'Data wpisu',
         day: 'Dzień',
         determinePatientAvailability: 'Określ dostępność pacjenta',
         duration: 'Czas trwania',
         durationInMinutes: '{{minutes}} min',
         edit: 'Edytuj',
         editEntry: 'Edytuj wpis z listy rezerwowej',
         encounterMode: 'Typ wizyty',
         encounterModeMap: {
            ON_SITE: 'Stacjonarna',
            VIDEO_CONSULTATION: 'Wideokonsultacja',
         },
         endTime: 'Godzina zakończenia',
         enterNameIdOrPhoneNumber: 'Wpisz nazwisko, imię, identyfikator lub numer telefonu...',
         entryCreatedSuccessfully: 'Pomyślnie dodano wpis na listę rezerwową.',
         entryNote: 'Notatka do wpisu',
         fetchError: 'Nie udało się pobrać danych, spróbuj ponownie',
         goBackToWaitlist: 'Wróć na listę rezerwową',
         healthcareProviderLocation: 'Miejsce Udzielania Świadczeń',
         hours: 'Godziny',
         leave: 'Wyjdź',
         makeSureThatServiceCanBePerformedOnSite:
            'Dodajesz wpis na wizytę stacjonarną z usługą online. Upewnij się, że wybrana usługa może zostać zrealizowana stacjonarnie.',
         makeSureThatServiceCanBePerformedOnline:
            'Dodajesz wpis na wideokonsultację z usługą stacjonarną. Upewnij się, że wybrana usługa może zostać zrealizowana online.',
         noAddedPatientsToTheWaitlist: 'Nie dodano jeszcze żadnych pacjentów do listy rezerwowej.',
         noMatchingResults: 'Brak pasujących wyników',
         noPatientsOnTheWaitlist: 'Brak pacjentów na liście rezerwowej',
         noService: 'Brak usługi',
         notSelected: 'Nie wybrano',
         note: 'Notatka',
         options: 'Opcje',
         patient: 'Pacjent',
         patientAvailabilityFilterDeselectorLabel: '{{dayOfWeek}}: {{timeOfDay}}',
         patientNotFound: 'Nie znaleziono pacjenta',
         patientSearchPlaceholder: 'Wpisz nazwisko, imię lub numer telefonu pacjenta...',
         patientSearchReachedMaxNumberOfCharacters: 'Maksymalna liczba znaków w wyszukiwarce wynosi 100.',
         phoneAbbreviation: 'tel.',
         preference: 'Preferencja: {{label}}',
         preferredDate: 'Preferowany termin',
         preferredDateAbbreviated: 'Pref. termin',
         preferredDates: 'PREFEROWANE TERMINY',
         priority: 'Priorytet',
         priorityLabelled: 'Priorytet: {{label}}',
         priorityPreference: 'Priorytetowa preferencja: {{label}}',
         receptionServices: 'Usługi recepcyjne',
         remove: 'Usuń',
         removeEntry: 'Usuń wpis',
         removingEntry: 'Usuwasz wpis z listy rezerwowej',
         reservationPreferenceFormFieldDescription: {
            LOCATION: 'Termin w konkretnej placówce',
            PRACTITIONER: 'Umówienie do konkretnego specjalisty',
            TIME: 'Najbliższy możliwy termin niezależnie od specjalisty i miejsca',
         },
         reservationPreferenceMap: {
            LOCATION: 'lokalizacja',
            PRACTITIONER: 'specjalista',
            TIME: 'termin',
         },
         reservationPreferenceMapUppercase: {
            LOCATION: 'Lokalizacja',
            PRACTITIONER: 'Specjalista',
            TIME: 'Termin',
         },
         restore: 'Przywróć',
         restorePatientToWaitlist: 'Przywróć pacjenta na listę oczekujących',
         save: 'Zapisz',
         selectedServiceIsNotPerfomedWithingLocation: 'Wybrana usługa nie jest realizowana w wybranym MUŚ.',
         service: 'Usługa',
         serviceProvidingLocation: 'Miejsce Udzielania Świadczeń',
         serviceProvidingLocationAbbreviation: 'MUŚ',
         showUrgentOnly: 'Pokazuj tylko pilne',
         specialist: 'Specjalista',
         startTime: 'Godzina rozpoczęcia',
         status: 'Status wpisu',
         statusDescription: {
            COMPLETED: 'Zrealizowany',
            CONFIRMED: 'Zapisany',
            PENDING: 'Oczekujący',
            REGISTERED: 'Zarezerwowany',
            REMOVED: 'Usunięty',
            SUSPENDED: 'Wykreślony',
         },
         statusMap: {
            COMPLETED: 'Zrealizowany',
            CONFIRMED: 'Zapisany',
            PENDING: 'Oczekujący',
            REGISTERED: 'Zarezerwowany',
            REMOVED: 'Usunięty',
            SUSPENDED: 'Wykreślony',
         },
         successfullyCancelledAppointmentAndSuspendedFromWaitlist:
            'Pomyślnie odwołano rezerwację wizyty i wykreślono wpis.',
         successfullyCancelledReservationAndRestoredToWaitlist:
            'Pomyślnie odwołano rezerwację wizyty i przywrócono pacjenta do listy oczekujących na termin.',
         successfullyConfirmedAppointment: 'Pomyślnie potwierdzono termin wizyty.',
         successfullyRemovedFromWaitlist: 'Pomyślnie usunięto wpis z listy rezerwowej.',
         successfullyRestoredToWaitlist: 'Pomyślnie przywrócono wpis na listę rezerwową.',
         successfullySuspendedFromWaitlist:
            'Pomyślnie wykreślono wpis z listy rezerwowej - w każdym momencie możesz go przywrócić.',
         suspendEntry: 'Wykreśl wpis',
         timeOfDayMap: {
            /* eslint-disable sort-keys-fix/sort-keys-fix */
            MORNING: 'do 12:00',
            AFTERNOON: '12:00-17:00',
            EVENING: 'po 17:00',
            /* eslint-enable */
         },
         urgent: {
            plural: 'Pilne',
            singular: 'Pilny',
         },
         urgentAppointment: 'Pilny termin',
         videoConsultation: 'Wideokonsultacja',
         waitlist: 'Lista rezerwowa',
         whatIsTheMostImportantForPatient: 'Co jest najważniejsze dla pacjenta?',
         wholeDay: 'Cały dzień',
         wholeWeek: 'Cały tydzień',
         withoutRestrictions: 'bez ograniczeń',
      },
   },
};

export const translationKeys = createScopedTranslationKeys(translations.pl, '~libs.desktop.pages.waitlist');
